<template>
  <div class="post">
    <hr />
    <h3 class="post-title">
      <router-link :to="title">{{ title }}</router-link>
    </h3>
    <span class="date">{{ date }}</span>
    <div v-html="body"></div>
  </div>
</template>

<script>
export default {
  name: "PostBody",
  props: ["id", "title", "date", "body"],
};
</script>

<style scoped>
</style>
